import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IPaymentInvoice } from '@/shared/model/payment-invoice.model';

const baseApiUrl = 'api/payment-invoices';
const baseSearchApiUrl = 'api/_search/payment-invoices?query=';

export default class PaymentInvoiceService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IPaymentInvoice> {
    return new Promise<IPaymentInvoice>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IPaymentInvoice): Promise<IPaymentInvoice> {
    return new Promise<IPaymentInvoice>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IPaymentInvoice): Promise<IPaymentInvoice> {
    return new Promise<IPaymentInvoice>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
